import React from 'react'
import { UploadFile } from 'antd'

interface Props {
  photo?: UploadFile
  video?: UploadFile
}

// только что выбранный файл ещё не на сервере — показываем его через objectURL
const useFileUrl = (file?: UploadFile) => {
  const [url, setUrl] = React.useState<string>()

  React.useEffect(() => {
    if (!file?.originFileObj) {
      setUrl(file?.url)
      return
    }
    const objectUrl = URL.createObjectURL(file.originFileObj)
    setUrl(objectUrl)
    return () => URL.revokeObjectURL(objectUrl)
  }, [file])

  return url
}

const frameStyle: React.CSSProperties = {
  width: '100%',
  maxHeight: 280,
  objectFit: 'contain',
  display: 'block',
  borderRadius: 8,
  background: '#f5f5f5'
}

export const BannerMediaPreview = ({ photo, video }: Props) => {
  const photoUrl = useFileUrl(photo)
  const videoUrl = useFileUrl(video)

  if (videoUrl) {
    return (
      <div style={{ marginBottom: 16 }}>
        <video src={videoUrl} poster={photoUrl} style={frameStyle} autoPlay muted playsInline loop />
      </div>
    )
  }

  if (photoUrl) {
    return (
      <div style={{ marginBottom: 16 }}>
        <img src={photoUrl} alt='Фото баннера' style={frameStyle} />
      </div>
    )
  }

  return (
    <div
      style={{
        ...frameStyle,
        height: 140,
        marginBottom: 16,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'rgba(0, 0, 0, 0.45)'
      }}
    >
      Пока ничего не загружено
    </div>
  )
}
